import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-table-expandable', 'expandRow', 'Expand row');
Labels.set('ui-table-expandable', 'collapseRow', 'Collapse row');
